import React, { useEffect, useState } from "react";
// import axios from "axios";
import { Controller } from "react-hook-form";
import {
  Autocomplete,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

// Example POST method implementation:
async function postData(url = '', data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    // mode: 'no-cors', // no-cors, *cors, same-origin
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  // console.log('postData response', response);

  // const response = await axios.post(url, { data })
  //   .then(res => {
  //     console.log(res);
  //     console.log(res.data);
  //   })

  return response.json(); // parses JSON response into native JavaScript objects
}

const baseAPIURL = process.env.REACT_APP_API_URL;
const localAPIURL = process.env.REACT_APP_LOCAL_API_URL;
const APIEndpoint = '/CPScan/GetCPInfo';

// console.log('APIURL', APIURL);

function CPLookup({
  name,
  control,
  label,
  placeholder,
  setError
}) {

  // const [search, setSearch] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [searchValue, setSearchValue] = useState(null);
  const [inputValue, setInputValue] = useState(null);

  useEffect(() => {
    // console.log('search', inputValue);
    // console.log('APIEndpoint', APIEndpoint);
    let optionsData = [];

    // const delayDebounceFn = setTimeout(() => {
    //   console.log(inputValue)
    // }, 1000)

    if (inputValue && inputValue !== '') {
      setIsLoading(true);
      // const apiData = {
      //   endpoint: APIEndpoint,
      //   searchData: {
      //     "Search": inputValue
      //   }
      // }

      if (inputValue === "CP" || !inputValue.match(/^[a-z0-9]+$/i)) {
        const optionsData = [];
        setError(
          'cp_number',
          {
            type: 'custom',
            //message: `Please enter a valid CP Number (e.g. CP1234567)`
            message: ``
          }
        );
        setOptions(optionsData);
        setIsLoading(false);
      }
      else {
        const apiData = {
          "method": "GET",
          "baseURL": baseAPIURL,
          "endpoint": `${APIEndpoint}?CPNumber=${inputValue}`
        }
        // const searchData = `{"Search": "${inputValue}"}`
        // const fullAPIURL = APIURL + APIQuery;
        // console.log('apiData', apiData);
        // console.log( baseAPIURL );

        postData(localAPIURL, apiData)
          .then(data => {
            //console.log('response data', data); // JSON data parsed by `data.json()` call
            //console.log('responsePreamble', data.responsePreamble.responseStatus);
            let optionsData = [];
            if (data.cpNumberId && data.responsePreamble.responseStatus == "Success") {
              optionsData = [{
                title: inputValue,
                value: data
              }];
              console.log('optionsData', optionsData);
              setOptions(optionsData);
              setIsLoading(false);
            } else {
              //data["itemDescription"] = "Not found. Please enter a valid CP Number (e.g. CP1234567)";
              optionsData = [{
                which: 'notfound',
                title: 'Not found. Please enter a valid CP Number (e.g. CP1234567)',
                value: data,
              }];
              console.log('optionsData', optionsData);
              setOptions(optionsData);
              setIsLoading(false);
            }
          })
          .catch((error) => {
            console.log('postData error', error);
            setOptions([]);
            setIsLoading(false);
          });
      }
    }
    else {
      setOptions([]);
    }

    return () => {
      setOptions([]);
      setIsLoading(false);
    }
  }, [searchValue, inputValue]);

  function locClk() {
    document.getElementById("xyz").focus();
    const ke = new KeyboardEvent('keydown', {
      bubbles: true, cancelable: true, keyCode: 13
    });
    document.getElementById("xyz").dispatchEvent(ke);
  }

  function handleKeyDown(event) {
    if (event.keyCode === 13 ) {
      event.preventDefault();
      // if ( !document.getElementById("xyz").focus() ) {
      //   event.preventDefault();
      // } else {
      //   console.log('pressed enter');
      // }
    }
  }

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          control={control}
          value={value}
          id={name}
          onChange={(event, newValue) => {
            if (typeof newValue === 'string') {
              setSearchValue({
                title: newValue,
              });
            } else if (newValue && newValue.inputValue) {
              //console.log( newValue.inputValue );
              // Create a new value from the user input
              setSearchValue({
                title: newValue.inputValue,
              });
            } else {
              //console.log( newValue );
              setSearchValue(newValue);
            }
            onChange(newValue);
          }}
          filterOptions={(x) => x}
          onInputChange={(event, newInputValue) => {
            if (newInputValue.length > 8) {
              setInputValue(newInputValue);
            }
          }}
          // filterOptions={(currentOptions, params) => {
          //   console.log('currentOptions', currentOptions);
          //   // return options;
          //   // console.log('currentOptions', currentOptions);
          //   // console.log('params', params);
          //   // const searchOptions = await getOptions(params);
          //   // console.log('searchOptions', searchOptions);
          //   const filtered = filter(currentOptions, params);
          //   console.log('filtered', filtered);

          //   const { inputValue } = params;
          //   // Suggest the creation of a new value
          //   const isExisting = currentOptions.some((option) => inputValue === option.title);
          //   if (inputValue !== '' && !isExisting) {
          //     filtered.push({
          //       inputValue,
          //       title: `Add "${inputValue}"`,
          //     });
          //   }

          //   return filtered;
          // }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          id="xyz"
          options={options}
          getOptionLabel={(option) => {
            // Value selected with enter, right from the input
            if (typeof option === 'string') {
              return option;
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
              return option.inputValue;
            }
            // Regular option
            if (option.which === 'notfound') {
              return '';
            } else{
              return option.title;
            }
          }}
          renderOption={(props, option) => <li {...props}>{option.title}</li>}
          freeSolo
          renderInput={(params) => (
            <TextField
              {...params}
              control={control}
              label={label}
              // name={name}
              placeholder={placeholder}
              //minlength="8"
              required
              InputProps={{
                ...params.InputProps,
               onKeyDown: (e) => {
                  if (e.key === 'Enter') {
                    e.stopPropagation();
                    e.preventDefault();
                  }
                },
                endAdornment: (
                  <>
                    {isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : (
                      <InputAdornment position="start">
                        <IconButton onClick={locClk} id="xyzb">
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    )}
                    {params.InputProps.endAdornment}
                  </>
                )
              }}
            />
          )}
        />
      )}
    />
  );
};

export default CPLookup;
